<template>
  <div>
    <el-row>
      <el-col :span="12">
        <rest-form-item prop="name" :label="$t('ApplicationForm_Field_Title')">
          <el-input v-model="model.name" data-qa="android-app-title-input" />
        </rest-form-item>
      </el-col>
      <el-col :span="12">
        <rest-form-item
          prop="android_bundle_id"
          :label="$t('ApplicationForm_Field_BundleID')"
        >
          <el-input
            v-model="model.android_bundle_id"
            data-qa="android-app-bundle-id-input"
          />
        </rest-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <rest-form-item
          prop="android_url"
          :label="$t('ApplicationForm_Field_AndroidUrlLink')"
        >
          <el-input
            v-model="model.android_url"
            data-qa="android-app-url-input"
          />
        </rest-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <rest-form-item
          prop="c"
          :label="$t('ApplicationForm_Field_AutoCreateEvents')"
        >
          <el-switch
            v-model="model.auto_create_events"
            :inactive-value="0"
            :active-value="1"
            data-qa="web-app-auto-create-events-switch"
          />
        </rest-form-item>
      </el-col>
      <el-col :span="12">
        <rest-form-item
          prop="c"
          :label="$t('ApplicationForm_Field_AutoCreateTags')"
        >
          <el-switch
            v-model="model.auto_create_tags"
            :inactive-value="0"
            :active-value="1"
            data-qa="web-app-auto-create-tags-switch"
          />
        </rest-form-item>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import RestFormItem from '@/common/components/rest/RestFormItem'

export default {
  name: 'AppAndroidForm',
  components: { RestFormItem },
  props: {
    model: {
      required: true,
      type: Object
    }
  },
  methods: {
    save() {
      this.$refs['form'].save()
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/account/components/AppAndroidForm.vue